var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stair_1_",
    "data-name": "stair (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.987,
    height: 123.141,
    viewBox: "0 0 159.987 123.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M8.489,118.9A4.244,4.244,0,0,1,0,118.9V95.63c0-.143.013-.286.026-.417A8.651,8.651,0,0,1,2.3,89.29,9.486,9.486,0,0,1,8.45,86.5a3.773,3.773,0,0,1,.664-.013l28.956.052V63.888c0-.143.013-.286.026-.43a6.212,6.212,0,0,1,1.432-3.88,5.755,5.755,0,0,1,4.479-2.018h.117v-.013H76.231v-21.6a3.8,3.8,0,0,1,.052-.664,6.788,6.788,0,0,1,2.07-4.4,7.386,7.386,0,0,1,4.336-1.94,3.235,3.235,0,0,1,.495-.026h32.654c0-6.627.365-14.309,0-20.819a9.048,9.048,0,0,1,1.445-4.661A7.3,7.3,0,0,1,123.141.013L123.6,0h32.146a4.244,4.244,0,0,1,0,8.489H124.326V33.161a4.245,4.245,0,0,1-4.244,4.244H84.707V61.792a4.245,4.245,0,0,1-4.244,4.244h-33.9V90.774h-.013a4.231,4.231,0,0,1-4.231,4.231L9.153,94.94a2.451,2.451,0,0,0-.69.143V95.2c.013.143.026.273.026.417V118.9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStair);
export default __webpack_public_path__ + "static/media/Stair.f87faad5.svg";
export { ForwardRef as ReactComponent };